import { format } from 'date-fns';
import { TriggeredMessagesResult } from 'modules/campaignsSentMessagesLogs/types';
import styled from 'styled-components';
import { colors } from 'ui/theme';

const StyleText = styled.span`
color: ${colors.textSecondary};
`;

export const DateColumn = ({ row }: { row: TriggeredMessagesResult }) => {
  const date = new Date(row.sendTimeMillis);
  const formattedDate = format(date, 'MMM dd, yyyy');
  const formattedTime = format(date, 'h:mm a');
  return (
    <p>
      {formattedDate}
      <StyleText>{` at ${formattedTime}`}</StyleText>
    </p>
  );
};
